export default ({ COLORS }) => ({
  container: {
    position: 'relative'
  },
  left: {
    textAlign: 'left'
  },
  all: {
    width: '60px'
  },
  allButton: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold'
  },
  contextMenuCell: {
    width: '60px'
  },
  pagination: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center'
  }
})
